import { Popup, Radio, Button, Toast } from 'antd-mobile';
import { useEffect, useState } from 'react';
import { hMacAjax as fetch } from '@/httpService';
import s from './index.module.scss';
import { RightOutline } from 'antd-mobile-icons';
import { convertTree } from '@/utils/convertTree_new';
import { cloneDeep } from 'lodash';
import ToastUtils from '@/utils/ToastUtils';
import SearchContent from './components/SearchContent';
import GrtLoading from '../GrtLoading/GRTLoading';

import ImageRender from '@/components/GrtImage/ImageRender';
const SelectOrganization = (props) => {
    let { setting = {}, updated, desc, formInstance } = props;
    const disabled = updated !== 0,
        // [options, setOptions] = useState([]),
        [initTreeOptions, setInitTreeOptions] = useState([]),
        [treeOptions, setTreeOptions] = useState([]);
    const [selectOrgVisible, setSelectOrgVisible] = useState(false);
    const [currLevelValue, setCurrLevelValue] = useState(null);
    const [selectLevelData, setSelectLevelData] = useState([]);
    const [searchStatus, setSearchStatus] = useState('0'); // 0-未搜索 1-搜索中，标记是否在搜索状态
    const [canLoad, setCanLoad] = useState(false);
    const [convertTreeType] = useState({
        id: 'id',
        key: 'id',
        parent_id: 'parent_id',
        value: 'id',
        name: 'org_name',
        pathName: 'pathName',
        children: 'children'
    });
    const [searchValue, setSearchValue] = useState(null);
    // TODO: 请求后端数据源接口
    let getOptions = () => {
        fetch.get(setting.requestUrl).then((res) => {
            if (res.success) {
                // setOptions(res.data);
                let showList = convertTree(res.data || [], convertTreeType); //列表上展示的数据----带层级的
                setInitTreeOptions(showList);
                setTreeOptions(showList);
                setCanLoad(true);
            }
        });
    };

    useEffect(() => {
        getOptions();
    }, []);
    const onCancel = () => {
        let select_data = formInstance.getFieldValue(props.en_name);
        if (!select_data || select_data !== currLevelValue?.id) {
            setSelectLevelData([]);
            setCurrLevelValue(null);
            formInstance.setFieldsValue({
                [props.en_name]: null
            });
            setTreeOptions(initTreeOptions);
        }
        // 关闭 清空已选数据
        setSelectOrgVisible(false);
    };

    const open = () => {
        if (!disabled) {
            setSelectOrgVisible(true);
        }
        return false;
    };

    const selectItem = (v) => {
        if (v) {
            let current_obj = treeOptions.filter((ele) => ele.id === v);
            setCurrLevelValue(current_obj[0]);
        }
    };

    const clickRadio = (v) => {
        if (v.is_optional === 0) {
            Toast.show({ content: '此组织无法被选中' });
            return false;
        }
    };
    const showNextLevel = (v) => {
        if (v.children?.length) {
            let data = cloneDeep(selectLevelData);
            // 判断已选数据中是否包含当前点击的数据
            let has_select_data = data.find((ele) => ele.id === v.id);
            // 如不存在，添加到已选数据
            if (!has_select_data) {
                data.push(v);
            }
            // 进入下级数据，清空选中的当前层级数据
            setCurrLevelValue(null);
            setSelectLevelData(data);
            setCanLoad(false);
            setTreeOptions([]);
            setTimeout(() => {
                setTreeOptions(v.children);
                setCanLoad(true);
                let container = document.getElementById('scrollContainer');
                if (container) {
                    console.log(container.scrollWidth);
                    container.scrollLeft = container.scrollWidth; // 水平滚动10像素
                }
            }, 10);
        }
    };
    const renderOptionItem = () => {
        return treeOptions.map((v, i) => {
            return (
                <div className={`${s['item']}`} key={i}>
                    <div className={s['item-left']}>
                        {/* is_optional  0:不可选 1：可选 */}
                        <Radio.Group onChange={selectItem} value={currLevelValue?.id}>
                            <Radio
                                value={v.id}
                                style={{
                                    '--icon-size': '16px',
                                    '--font-size': '15px',
                                    '--gap': '15px'
                                }}
                                disabled={v.is_optional === 0}
                                onClick={() => clickRadio(v)}
                            >
                                {v.org_name}
                            </Radio>
                        </Radio.Group>
                        {searchStatus === '1' ? <div className={s['path']}>{v.pathName}</div> : null}
                    </div>
                    {/* 所搜中的数据不展示下级 */}
                    {searchStatus === '0' ? (
                        <div className={s['item-right']} onClick={() => showNextLevel(v)}>
                            {v.children && v.children.length > 0 ? <RightOutline fontSize={12} color="#999999" /> : null}
                        </div>
                    ) : null}
                </div>
            );
        });
    };
    // 渲染空数据页面
    const renderEmptyWrap = () => {
        return (
            <div className={s['org-empty']}>
                <div className={s['img-wrap']}>
                    <ImageRender src={require('@/assets/images/dynamicForm/select_org_empty.webp')} />
                </div>
                <div className={s['tips']}>抱歉，暂无数据</div>
            </div>
        );
    };
    // 点击面包屑上的层级回到指定层级组织列表
    const backProintLevel = (v) => {
        // 根据点击面包屑指定层级parent_id 找到点击节点的父节点，父节点的children为需要显示的列表数据
        if (v.parent_id === '-1') {
            setTreeOptions(initTreeOptions);
            setSelectLevelData([]);
            return false;
        }
        // const parent_node = findParent(initTreeOptions, v);
        setTreeOptions(v?.children || []);
        // 根据当前点击面包屑指定层级id 找到面包屑数据中所在的索引，删除之后所有数据，渲染面包屑
        if (selectLevelData?.length > 0) {
            let crumbs_data = cloneDeep(selectLevelData);
            let idx = crumbs_data.findIndex((ele) => ele.id === v.id);
            crumbs_data.splice(idx + 1, crumbs_data.length - (idx + 1));
            setSelectLevelData(crumbs_data);
        }
        // 返回指定层级也清空选中的当前数据  -暂时先不清楚
        setCurrLevelValue(null);
    };
    const renderOrganizationCrumbs = () => {
        return (
            <div className={s['crumbs-list']} id="scrollContainer">
                {/* 加一个全部 */}
                <div
                    className={s['parents-crumbs']}
                    onClick={() =>
                        backProintLevel({
                            parent_id: '-1'
                        })
                    }
                >
                    全部
                    <RightOutline fontSize={12} color="#999999" />
                </div>
                {selectLevelData.map((v, i) => {
                    return selectLevelData.length - 1 === i ? (
                        <div className={s['active-crumbs']} key={i}>
                            {v.org_name}
                        </div>
                    ) : (
                        <div className={s['parents-crumbs']} key={i} onClick={() => backProintLevel(v)}>
                            {v.org_name}
                            <RightOutline fontSize={12} color="#999999" />
                        </div>
                    );
                })}
            </div>
        );
    };

    const findNodesByField = (treeData, field, value) => {
        let result = [];
        function search(nodes) {
            nodes.forEach((node) => {
                if (node[field].includes(value)) {
                    result.push(node);
                }
                if (node.children && node.children.length > 0) {
                    search(node.children);
                }
            });
        }
        search([...treeData]); // 使用拷贝以避免修改原始树结构
        return result;
    };
    // 根据组织名称进行搜索
    const searchByOrgName = (val) => {
        if (!val || val === '') {
            ToastUtils.showToast('搜索内容不能为空');
            return false;
        }
        setCanLoad(false);
        setTreeOptions([]);
        setTimeout(() => {
            setSearchStatus('1');
            let search_data = findNodesByField(initTreeOptions, 'org_name', val);
            setTreeOptions(search_data);
            setSelectLevelData([]);
            setCurrLevelValue(null);
            setCanLoad(true);
        }, 10);
    };
    // 清空搜索
    const resetSearch = () => {
        // 根据点击面包屑指定层级parent_id 找到点击节点的父节点，父节点的children为需要显示的列表数据
        setTreeOptions(initTreeOptions);
        setSearchStatus('0');
        setSearchValue('');
        setCurrLevelValue(null);
    };

    const onSubmit = () => {
        if (!currLevelValue || currLevelValue === '') {
            ToastUtils.showToast('请先选择组织');
            return false;
        }
        formInstance.setFieldsValue({
            [props.en_name]: currLevelValue.id
        });
        setSelectOrgVisible(false);
    };
    const renderChooseItem = () => {
        if (currLevelValue?.id) {
            return (
                <div className={`${s['dynamic-cascade-item-value']}`} onClick={open}>
                    {currLevelValue.org_name}
                </div>
            );
        }
        return (
            <div className={`${s['dynamic-cascade-item']}`} onClick={open}>
                {desc || '请选择'}
            </div>
        );
    };
    return (
        <>
            {renderChooseItem()}
            {selectOrgVisible ? (
                <Popup
                    visible={selectOrgVisible}
                    onMaskClick={onCancel}
                    className={s['selected-organization-popup']}
                    bodyStyle={{ borderTopLeftRadius: '16px', borderTopRightRadius: '15px' }}
                >
                    <div className={s['popup-organization-content']} id="myElement">
                        <div className={`scroll-header ${s['header']}`}>
                            <div className={s['header-title']}>选择组织</div>
                            <div className={s['cancel']} onClick={onCancel}>
                                <ImageRender src={require('@/assets/images/dynamicForm/close.webp')} />
                            </div>
                        </div>
                        <div className={s['organization-options-content']}>
                            {
                                <SearchContent
                                    onSearch={searchByOrgName}
                                    onClear={resetSearch}
                                    searchValue={searchValue}
                                    setSearchValue={setSearchValue}
                                />
                            }
                            {selectLevelData?.length > 0 ? <div className={s['organization-crumbs']}>{renderOrganizationCrumbs()}</div> : null}

                            <div className={s['organization-list-wrap']}>
                                {!canLoad ? <GrtLoading></GrtLoading> : treeOptions?.length ? renderOptionItem() : renderEmptyWrap()}
                            </div>
                        </div>
                        {treeOptions?.length ? (
                            <div className={s['footer-btn']}>
                                <Button
                                    style={{
                                        width: '90%',
                                        background: '#3B70FF',
                                        color: '#ffffff',
                                        fontSize: '17px',
                                        fontWeight: '400',
                                        height: '48px',
                                        borderRadius: '7px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                    type="primary"
                                    onClick={() => onSubmit()}
                                >
                                    确定
                                </Button>
                            </div>
                        ) : null}
                    </div>
                </Popup>
            ) : null}
        </>
    );
};
export default SelectOrganization;
